var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlLgLocation = function SvgVaknlLgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    y: 24,
    fill: "#E6E6E6",
    fillRule: "nonzero",
    rx: 1.001
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 5,
    y: 24,
    fill: "#E6E6E6",
    fillRule: "nonzero",
    rx: 1.001
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 10,
    y: 24,
    fill: "#E6E6E6",
    fillRule: "nonzero",
    rx: 1.001
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 18,
    y: 12,
    fill: "#E6E6E6",
    fillRule: "nonzero",
    rx: 1.001,
    transform: "rotate(90 20 14)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 18,
    y: 17,
    fill: "#E6E6E6",
    fillRule: "nonzero",
    rx: 1.001,
    transform: "rotate(90 20 19)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 5,
    fill: "#3D9B8B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.901 12.09h-3.52l-1.52 11.4-.61 4.6H23.711l-2.13-16h-3.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3AD05",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.13 2.111A7.038 7.038 0 0 0 14.186.333 7.233 7.233 0 0 0 12.019 0c-.219 0-.437.011-.655.033a.82.82 0 0 0-.156.011c-.156.023-.311.045-.467.078a.7.7 0 0 0-.222.034c-.131.026-.261.06-.389.1-.13.021-.257.059-.378.111-.26.076-.513.177-.755.3a9.273 9.273 0 0 0-.489.244 7.181 7.181 0 0 0-3.689 5.9 2.568 2.568 0 0 0-.022.411c0 4.989 6.078 12.733 7.211 12.778h.022c1.134-.045 7.211-7.789 7.211-12.778a7.233 7.233 0 0 0-2.111-5.111zm-5.1 7.756a2.545 2.545 0 1 1 0-5.09 2.545 2.545 0 0 1 0 5.09h0z"
  }))));
};
export default SvgVaknlLgLocation;